import {getArtifactVersion} from '@wix/music-shared/dist/src/utils/get-artifact-version/index';

export function getArtifactsVersions() {
  const getWindowVersion = getArtifactVersion('music-get-window', {
    hostname: location.hostname,
    pathname: window.__STATICS_BASE_URL__ || location.pathname,
  });
  return [getWindowVersion, window.__SERVER_VERSION__].filter(Boolean).join('|');
}
